import { Component } from "react";

export default class CologuardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Cologuard frontend error", { error, errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="cologuard-phase2">
          <div className="cg-admin-shell">
            <section className="cg-panel cg-error-boundary" role="alert">
              <span className="cg-kicker">Cologuard</span>
              <h1>Something went wrong</h1>
              <p>Reload the page to restore your session. If the problem continues, contact support.</p>
              <button type="button" onClick={() => window.location.reload()}>
                Reload application
              </button>
            </section>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
